/*eslint-disable*/
export default {
    inserted(el) {
        el.focus();
    }
}
